import { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import './ResetPassword.css';

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const { token } = useParams();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        try {
            const res = await api.put(`/auth/reset-password/${token}`, { password });
            setMessage(res.data.message);
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            setError(err.response?.data?.message || 'Error al restablecer');
        }
    };

    return (
        <div className="reset-wrapper">
            <div className="reset-container">
                <div className="reset-box">
                    <div className="reset-header">
                        <h2>Nueva Contraseña</h2>
                        <p>Ingresa tu nueva contraseña</p>
                    </div>
                    {error && <div className="alert alert-danger">{error}</div>}
                    {message && <div className="alert alert-success">{message}</div>}
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Contraseña</label>
                            <input
                                type="password"
                                className="form-control"
                                placeholder="Nueva contraseña (mín. 6 caracteres)"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                minLength={6}
                            />
                        </div>
                        <button type="submit" className="btn btn-primary w-100">
                            Cambiar contraseña
                        </button>
                    </form>
                    <div className="reset-footer">
                        <Link to="/login">Volver al inicio de sesión</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;